import { useQuery } from "react-query";

import offeringAPIService from "../../services/api/offering";

function fetchCustomerOfferingDetail(key: string, offeringCode: string) {
  return offeringAPIService.getDetails(offeringCode);
}

export function useCustomerOfferingDetailQuery(offeringCode: string) {
  return useQuery(
    Boolean(offeringCode) && ["customerOfferingDetail", offeringCode],
    fetchCustomerOfferingDetail,
  );
}
